import Plot from "../../../../src/components/plotly";
import figure1 from "../../../../../images/news/tentris107_all.json";
import * as React from 'react';
export default {
  Plot,
  figure1,
  React
};